import { render } from "./TransactionView.vue?vue&type=template&id=6c602400"
import script from "./TransactionView.vue?vue&type=script&lang=js"
export * from "./TransactionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__